import { Component } from '@angular/core';

@Component({
  selector: 'app-imgsigner',
  standalone: false,
  templateUrl: './imgsigner.component.html',
  styleUrls: ['./imgsigner.component.css']
})
export class ImgsignerComponent {

  constructor() { }
}
